


































import { Component, Mixins } from "vue-property-decorator";
import {ContentService} from "@/service/content.service"
import {FeedbackResponseContent} from "@/models/content/feedback-response"
import CommonMixin from "@/mixins/common-mixins";
import { AppData } from "@/models/app-data"
@Component({
  components: {}
})
export default class FeedbackResponse extends Mixins(CommonMixin)  {
  content = {} as FeedbackResponseContent

  textDirection = "ltr";

  async mounted(): Promise<void> {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getFeedbackResponseContent();
      this.textDirection = contentService.TextDirection()
  }
}
